import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-floating-target',
  templateUrl: './floating-target.component.html',
  styleUrls: ['./floating-target.component.scss']
})
export class FloatingTargetComponent implements OnInit {

  @Input() dotPosition: {x: number; y: number};
  @Input() arrowAngle: number;

  constructor() {
  }

  ngOnInit() {
  }

}
